'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Config;

var _utils = require('./utils');

var _validation = require('./validation');

var defaultHeaders = {
    'content-type': 'text/plain; charset=UTF-8',
    'plural-forms': 'nplurals=2; plural=(n!=1);'
};

var isProd = process && process.env && process.env.NODE_ENV === 'production';

function Config() {
    var _this = this;

    var config = {
        locales: {},
        currentLocales: [],
        currentLocale: 'en',
        dedent: true,
        headers: defaultHeaders
    };

    this.addLocale = function (locale, localeData) {
        if (!isProd) (0, _validation.validateLocaleCode)(locale);
        if (!isProd) (0, _validation.validateLocaleData)(localeData);
        localeData = (0, _utils.transformTranslateObj)(localeData);
        config.locales[locale] = localeData;
    };

    this.setCurrentLocale = function (locale) {
        config.currentLocale = locale;
    };

    this.setDedent = function (dedent) {
        config.dedent = dedent;
    };

    this.setHeaders = function (headers) {
        config.headers = headers;
    };

    this.setCurrentLocales = function (locales) {
        if (!isProd) (0, _validation.validateLocales)(locales, _this.getAvailLocales());
        config.currentLocales = locales;
    };

    this.getAvailLocales = function () {
        return config.locales;
    };

    this.getCurrentLocales = function () {
        return config.currentLocales;
    };

    this.getCurrentLocale = function () {
        return config.currentLocale;
    };

    this.isDedent = function () {
        return config.dedent;
    };

    this.getHeaders = function () {
        return config.headers;
    };
}


//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/c-3po/dist/config.js
// module id = 1424
// module chunks = 7